window.AdminLogs = function AdminLogs() {
  const [logs, setLogs] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [searchQuery, setSearchQuery] = React.useState('');
  const [entityFilter, setEntityFilter] = React.useState('All');

  React.useEffect(() => {
    fetchLogs();
    const handleSync = () => fetchLogs();
    window.addEventListener('storage', handleSync);
    window.addEventListener('novatek_app_added', handleSync);
    return () => {
      window.removeEventListener('storage', handleSync);
      window.removeEventListener('novatek_app_added', handleSync);
    };
  }, []);

  const fetchLogs = async () => {
    setLoading(true);
    try {
      const res = await window.apiClient.get('logs.php?limit=100');
      if (res && res.success) setLogs(res.data || []);
    } catch (e) {
      console.warn('Logs fetch warning:', e);
      setLogs([
        { id: 901, username: 'admin', action: 'System Administrator logged into admin portal', entity_type: 'auth', ip_address: '127.0.0.1', created_at: new Date().toISOString().replace('T', ' ').substring(0, 19) },
        { id: 902, username: 'admin', action: 'Received Application: Dr. Rahul Sharma (Start Your Journey Portal)', entity_type: 'application', ip_address: '127.0.0.1', created_at: '2026-07-25 09:30:00' },
        { id: 903, username: 'system', action: 'System initialized & database connection active', entity_type: 'system', ip_address: '127.0.0.1', created_at: '2026-07-25 09:00:00' }
      ]);
    } finally {
      setLoading(false);
    }
  };

  const filteredLogs = logs.filter((l) => {
    const matchesEntity = entityFilter === 'All' || (l.entity_type || 'general') === entityFilter;
    const matchesSearch = (l.action || '').toLowerCase().includes(searchQuery.toLowerCase()) ||
                          (l.username || '').toLowerCase().includes(searchQuery.toLowerCase());
    return matchesEntity && matchesSearch;
  });

  return (
    <div className="space-y-6 animate-fadeIn">
      
      {/* Header */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 bg-white p-6 rounded-2xl border border-slate-200 shadow-sm">
        <div>
          <h1 className="font-serif text-2xl font-bold text-slate-900">System Audit & Activity Logs</h1>
          <p className="font-sans text-xs text-slate-500">Complete audit trail of login events, content edits, career postings, and product modifications.</p>
        </div>
        <button onClick={fetchLogs} className="bg-slate-100 hover:bg-slate-200 text-slate-700 font-mono text-xs px-4 py-2.5 rounded-lg border border-slate-300 transition-all flex items-center gap-2 cursor-pointer">
          <span className="material-symbols-outlined text-base">refresh</span>
          <span>Refresh Audit Logs</span>
        </button>
      </div>

      {/* Filter Bar */}
      <div className="bg-white p-4 rounded-xl border border-slate-200 shadow-sm flex flex-col sm:flex-row justify-between items-center gap-4">
        <div className="relative w-full sm:w-80">
          <span className="material-symbols-outlined absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 text-base">search</span>
          <input
            type="text"
            placeholder="Search by action or user..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full pl-9 pr-4 py-2 text-xs bg-slate-50 border border-slate-300 rounded-lg text-slate-900 outline-none focus:border-secondary font-mono"
          />
        </div>

        <div className="flex items-center gap-2 w-full sm:w-auto">
          <span className="font-mono text-xs text-slate-600">Entity:</span>
          <select
            value={entityFilter}
            onChange={(e) => setEntityFilter(e.target.value)}
            className="px-3 py-2 bg-slate-50 border border-slate-300 rounded text-xs text-slate-800 outline-none font-mono"
          >
            <option value="All">All Categories</option>
            <option value="auth">Authentication</option>
            <option value="application">Applications</option>
            <option value="inquiry">Inquiries</option>
            <option value="system">System</option>
            <option value="general">General</option>
          </select>
        </div>
      </div>

      {/* Audit Logs Table */}
      <div className="bg-white rounded-2xl border border-slate-200 overflow-hidden shadow-sm">
        <div className="overflow-x-auto">
          <table className="w-full text-left text-xs font-sans">
            <thead className="bg-slate-50 text-slate-500 font-mono text-[10px] uppercase border-b border-slate-200">
              <tr>
                <th className="p-4">TIMESTAMP</th>
                <th className="p-4">USER</th>
                <th className="p-4">ACTION PERFORMED</th>
                <th className="p-4">ENTITY TYPE</th>
                <th className="p-4">IP ADDRESS</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100 font-mono">
              {filteredLogs.length === 0 ? (
                <tr>
                  <td colSpan="5" className="p-8 text-center text-slate-400 font-mono">No audit logs match current search/filter.</td>
                </tr>
              ) : (
                filteredLogs.map((l) => (
                  <tr key={l.id} className="hover:bg-slate-50 transition-colors">
                    <td className="p-4 font-mono text-slate-500 text-[11px] whitespace-nowrap">{l.created_at}</td>
                    <td className="p-4 font-bold text-slate-900 font-mono">{l.username || 'admin'}</td>
                    <td className="p-4 text-slate-700 font-sans">{l.action}</td>
                    <td className="p-4 font-mono">
                      <span className="bg-slate-100 text-secondary border border-slate-200 px-2.5 py-1 rounded text-[10px] uppercase font-bold">
                        {l.entity_type || 'general'}
                      </span>
                    </td>
                    <td className="p-4 font-mono text-slate-500">{l.ip_address || '127.0.0.1'}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

    </div>
  );
};
